import { render, staticRenderFns } from "./BrandVehicleEdit.vue?vue&type=template&id=e1086296"
import script from "./BrandVehicleEdit.vue?vue&type=script&lang=js"
export * from "./BrandVehicleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports